import { DrawParams } from "./types";

export default function drawCurrentFreqLine({
  svg,
  xScale,
  freq,
  contentHeight,
}: DrawParams) {
  const selector = "currentFreqLine";

  svg
    .selectAll(`line.${selector}`)
    .data([1])
    .join("line")
    .attr("class", `${selector}`)
    .attr("fill", "none")
    .attr("stroke", "white")
    .attr("stroke-width", 2)
    .attr("x1", xScale(freq))
    .attr("x2", xScale(freq))
    .attr("y1", 0)
    .attr("y2", contentHeight);
}
